import request from "../plugins/axios";
import router from '../router';

/**
 * 检查登录状态
 * @param {Object} res - 响应对象
 * @returns {Promise} - 处理后的响应对象或拒绝的Promise
 */
function checkLoginStatus(res) {
	if (res.data && res.data.is_login && res.data.is_login === 2) {
		router.push('/robot/login');
		return Promise.reject('登录已过期，请重新登录');
	}
	return res;
}

export function wxWorkInit(data) {
	return request({
		url: '/scrm/wxworkInit',
        method: 'POST',
        data
	})
}

export function checkCode(data) {
	return request({
		url: '/scrm/CheckCode',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

export function getLabelList(data) {
	return request({
		url: '/scrm/getLabelList',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

export function getUserListByLabel(data) {
	return request({
		url: '/scrm/getUserListByLabel',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

/**
 * 获取群组列表
 * @param {Object} data - 查询参数
 * @param {string} [data.room_name] - 搜索群昵称
 * @returns {Promise} - 包含群组列表的Promise对象
 */
export function getUsersChatroomList(data) {
	return request({
		url: '/scrm/getUsersChatroomList',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

/**
 * 添加消息发送任务
 * @param {Object} data - 发送任务数据
 * @param {string} data.send_time - 发送时间，格式为"YYYY-MM-DD HH:mm:ss"
 * @param {string} data.send_msg - 发送的消息内容
 * @param {string} data.send_type - 发送类型，1：发送给用户，3：发送给指定标签下的用户
 * @param {string} [data.send_user_list] - 发送的用户id，多个以英文逗号拼接，send_type=1的时候必传
 * @param {string} [data.send_tag_list] - 发送的标签id，多个以英文逗号拼接，send_type=3的时候必传
 * @returns {Promise} - 包含发送任务结果的Promise对象
 */
export function addMsgSendTask(data) {
	return request({
		url: '/scrm/addMsgSendTask',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}



/**
 * 同步标签和用户
 * @param {Object} data - 同步数据
 * @returns {Promise} - 包含同步结果的Promise对象
 */
export function syncLabelAndUser(data) {
	return request({
		url: '/scrm/syncLabelAndUser',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

/**
 * 获取消息发送任务列表
 * @param {Object} data - 查询参数
 * @param {number} data.page - 页码
 * @param {number} data.perPage - 每页数量
 * @returns {Promise} - 包含任务列表的Promise对象
 */
export function getMsgSendTaskList(data) {
	return request({
		url: '/scrm/getMsgSendTaskList',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

/**
 * 删除消息发送任务
 * @param {Object} data - 删除参数
 * @param {number} data.id - 任务ID
 * @returns {Promise} - 包含删除结果的Promise对象
 */
export function delMsgSendTask(data) {
	return request({
		url: '/scrm/delMsgSendTask',
        method: 'POST',
        data
	}).then(checkLoginStatus)
}

export function getChatWorkRobotTrainList() {
	return request({
		url: '/scrm/getChatWorkRobotTrainList',
		method: 'GET'
	})
}

/**
 * [机器人]CDN上传网络图片
 * @param data
 * @returns {*}
 */
export function CdnUploadImgLink(data) {
    return request({
        url: '/scrm/CdnUploadImgLink',
        method: 'POST',
        data
    })
}
